module.exports = __webpack_public_path__ + "static/media/galaxy.5bdc45f0.jpg";